import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Select from 'react-select';
import CommonButton from '../CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import '../../../assets/css/componentStyles/FormInputField.css';

const CUSTOM_STYLES = {
  control: (base) => ({
    ...base,
    borderRadius: '30px',
    border: `2px solid #c7c5db`,
    padding: '0.5rem 1rem',
    height: 'auto',
    backgroundColor: '#fff',
    color: '#050220',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#c7c5db',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#050220',
    opacity: 0.5,
  }),
  menu: (base) => ({ ...base, zIndex: 99999 }),
};

function FormSelectFieldInner(props) {
  const {
    label,
    placeholder = '',
    form,
    field,
    options,
    onChangeHandler,
    classNames,
    withButton,
    buttonLabel,
    buttonSize,
    buttonClassNames,
    buttonHandleClick,
    buttonDisabled,
    rowClassNames,
    suffix,
    disabled,
    invalid,
    required,
    selectProps,
    labelVariant,
    blurInputOnSelect,
  } = props;

  const error = form.errors[field.name];
  const touched = form.touched[field.name];

  const splittedName = field?.name?.split('.');

  const getSplitedName = (params) => {
    let temp = form.values;
    // eslint-disable-next-line no-restricted-syntax
    for (const param of params) {
      temp = temp[param];
    }

    return temp;
  };

  const value =
    splittedName?.length > 1 ? getSplitedName(splittedName) : form.values[field.name] || '';

  const isBordered = labelVariant === 'bordered';
  const labelClassName = `form-input-field-label ${required ? 'label-required' : ''} ${
    disabled ? 'form-input-field-label__disabled' : ''
  }`;

  return (
    <Row className={rowClassNames}>
      <Col>
        {!isBordered && <Label className={labelClassName}>{label}</Label>}
        <FormGroup
          className={`form-select-field-wrapper ${
            isBordered ? 'form-group--bordered-label' : ''
          }`}
        >
          {isBordered && <Label className={labelClassName}>{label}</Label>}
          <div className="form-select-field-inner-wrapper">
            <Select
              styles={isBordered ? CUSTOM_STYLES : {}}
              options={options}
              placeholder={placeholder}
              name={field.name}
              value={value && typeof value === 'object' && 'value' in value ? value : ''}
              isDisabled={form.isSubmitting || disabled}
              onBlur={() => form.setFieldTouched(field.name, true)}
              onChange={(option) => {
                form.setFieldValue(field.name, option);
                if (typeof onChangeHandler === 'function') {
                  onChangeHandler(option);
                }
              }}
              blurInputOnSelect={blurInputOnSelect}
              className={`${classNames} ${(touched && error) || invalid ? 'is-invalid' : ''}`}
              classNamePrefix="react-select"
              {...selectProps}
            />
            {suffix && <span className="form-select-field__suffix">{suffix}</span>}
            {withButton && (
              <CommonButton
                label={buttonLabel}
                size={buttonSize}
                className={buttonClassNames}
                handleClick={buttonHandleClick}
                disabled={buttonDisabled}
                variant={
                  buttonDisabled ? CommonButtonVariants.DISABLED : CommonButtonVariants.PRIMARY
                }
              />
            )}
          </div>
          {(form.submitCount > 0 || touched) && error && (
            <label className="form-select-field__label error-label">{error}</label>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormSelectField(props) {
  return <Field {...props} component={FormSelectFieldInner} />;
}

FormSelectField.defaultProps = {
  placeholder: '',
  options: [],
  onChangeHandler: () => {},
  label: '',
  classNames: '',
  withButton: false,
  buttonLabel: '',
  buttonSize: '',
  buttonClassNames: '',
  buttonHandleClick: null,
  buttonDisabled: false,
  rowClassNames: '',
  className: '',
  suffix: '',
  disabled: false,
  invalid: false,
  required: false,
  selectProps: {},
  blurInputOnSelect: true,
};

FormSelectField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChangeHandler: PropTypes.func,
  classNames: PropTypes.string,
  withButton: PropTypes.bool,
  buttonLabel: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonClassNames: PropTypes.string,
  buttonHandleClick: PropTypes.func,
  buttonDisabled: PropTypes.bool,
  rowClassNames: PropTypes.string,
  className: PropTypes.string,
  suffix: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  selectProps: PropTypes.object,
  blurInputOnSelect: PropTypes.bool,
};

export default FormSelectField;
